export default "__VITE_ASSET__DEAqbJsj__"